import { LoadableAfterPaint } from '@confluence/loadable';

export const SpaceTrashPortal = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceTrashPortal" */ './SpaceTrashPortal'))
			.SpaceTrashPortal,
	name: 'SpaceTrashPortal',
});
